export const userConstants = {
    CART_ITEM_REQUEST: 'CART_ITEM_REQUEST',
    CART_ITEM_SUCCESS: 'CART_ITEM_SUCCESS',
    CART_ITEM_ERROR: 'CART_ITEM_ERROR',

    FETCH_CART_ITEM_SUCCESS: 'FETCH_CART_ITEM_SUCCESS',
}